import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e5f7f1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inline-block" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "menu-with-tabs__close"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "menu-with-tabs-mobile" }
const _hoisted_8 = {
  key: 0,
  class: "menu-with-tabs-content-box-slot"
}
const _hoisted_9 = { id: "menu-slot" }

import { computed, onMounted, ref, watch } from 'vue';
import { BtnsForTabsMenuType, OptionsType } from '@/types';
import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseMenuWithTabs',
  props: {
    componentBtns: {},
    activeComponent: {},
    hideTitle: {},
    withRadius: { type: Boolean },
    withClose: { type: Boolean },
    bgColor: {},
    container: { type: Boolean },
    greenMobile: { type: Boolean },
    mobileShowAllBlocks: { type: Boolean },
    btnIdsWithErrors: {}
  },
  emits: ['changeActiveBtn', 'close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const windowWidth = computed((): number => {
  return useAppStore().window;
});

const changeCurrentComponent = (componentBtnId: number | string) => {
  emit('changeActiveBtn', componentBtnId);
};
const preparedComponentBtns = computed((): OptionsType[] => {
  return props.componentBtns.map(el => {
    return { id: el.id, name: el.title, icon: el.icon };
  });
});

const cssProps = computed(() => {
  return {
    '--bg-color': props.bgColor,
  };
});

const maxTabWidth = ref({ '--max-active-tab-width': '100%' });
const updateMaxTabWidth = () => {
  const slotBlockWidth = document.getElementById('menu-slot')?.offsetWidth;

  if (slotBlockWidth) {
    maxTabWidth.value['--max-active-tab-width'] =
      `${(slotBlockWidth - 10) / props.componentBtns.length}px`;
  }
};

onMounted(() => {
  setTimeout(() => {
    updateMaxTabWidth();
  }, 100);
});
watch(
  () => windowWidth.value,
  () => {
    updateMaxTabWidth();
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_expansion_panels = _resolveComponent("base-expansion-panels")!
  const _component_base_select_input = _resolveComponent("base-select-input")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([{ container: _ctx.container }, "pb-0 none-Mobile"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass([{
          open: _ctx.activeComponent,
        }, "menu-with-tabs"])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentBtns, (componentBtn, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "menu-with-tabs__tab"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([{
              active: _ctx.activeComponent === componentBtn?.id,
              error:
                _ctx.btnIdsWithErrors && _ctx.btnIdsWithErrors.find(el => el === componentBtn?.id),
            }, "menu-with-tabs__tab-btn"]),
                style: _normalizeStyle({ ...cssProps.value, ...maxTabWidth.value }),
                onClick: ($event: any) => (changeCurrentComponent(componentBtn.id))
              }, [
                (componentBtn.icon)
                  ? (_openBlock(), _createBlock(_component_base_icon, {
                      key: 0,
                      color: _ctx.activeComponent === componentBtn?.id ? '#009D3E' : 'white',
                      name: componentBtn.icon,
                      height: "18",
                      width: "18"
                    }, null, 8, ["color", "name"]))
                  : _createCommentVNode("", true),
                (_ctx.hideTitle ? windowWidth.value >= _ctx.hideTitle : true)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass([{
                active: _ctx.activeComponent === componentBtn?.id,
                error:
                  _ctx.btnIdsWithErrors &&
                  _ctx.btnIdsWithErrors.find(el => el === componentBtn?.id),
              }, "menu-with-tabs__tab-btn-title"])
                    }, [
                      _renderSlot(_ctx.$slots, "title", { data: componentBtn }),
                      (!_ctx.$slots.title)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(componentBtn.title), 1))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true)
              ], 14, _hoisted_2),
              (i !== _ctx.componentBtns.length - 1 ? true : _ctx.withClose)
                ? (_openBlock(), _createBlock(_component_base_divider, {
                    key: 0,
                    color: 
              componentBtn?.id !== _ctx.activeComponent &&
              _ctx.componentBtns.findIndex(el => el.id === _ctx.activeComponent) - 1 !== i
                ? '#ffffff'
                : 'transparent'
            ,
                    inset: "20px",
                    vertical: ""
                  }, null, 8, ["color"]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.withClose)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_base_icon, {
                  clickable: "",
                  color: "white",
                  height: "15",
                  name: "close",
                  width: "15",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
                })
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ], 2),
    (_ctx.mobileShowAllBlocks && _unref(useAppStore)().getWindowWidth() <= 600)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentBtns, (category) => {
            return (_openBlock(), _createBlock(_component_base_expansion_panels, {
              key: category.id,
              isError: !!(_ctx.btnIdsWithErrors && _ctx.btnIdsWithErrors.find(el => el === category?.id)),
              styleType: "simple-green"
            }, {
              title: _withCtx((titleProps) => [
                _renderSlot(_ctx.$slots, "title", { data: category }),
                (!_ctx.$slots.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(category.title), 1))
                  : _createCommentVNode("", true)
              ]),
              content: _withCtx((contentProps) => [
                _renderSlot(_ctx.$slots, "content", {
                  data: category.id
                })
              ]),
              _: 2
            }, 1032, ["isError"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{
      active: _ctx.activeComponent,
      withRadius: _ctx.withRadius,
    }, "menu-with-tabs-content"]),
          style: _normalizeStyle(cssProps.value)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([{ withRadius: _ctx.withRadius }, "menu-with-tabs-content-box"]),
            style: _normalizeStyle(cssProps.value)
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_select_input, {
                modelValue: _ctx.activeComponent,
                options: preparedComponentBtns.value,
                showLabel: false,
                type: _ctx.greenMobile ? 'green' : 'mainColorBorder',
                label: "Фильтрация",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (changeCurrentComponent($event)))
              }, null, 8, ["modelValue", "options", "type"]),
              (_ctx.withClose)
                ? (_openBlock(), _createBlock(_component_base_button, {
                    key: 0,
                    height: "34",
                    icon: "",
                    width: "50",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_base_icon, {
                        clickable: "",
                        color: "white",
                        height: "15",
                        name: "close",
                        width: "15"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (_ctx.activeComponent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _renderSlot(_ctx.$slots, "content", { data: _ctx.activeComponent })
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 6)
        ], 6))
  ], 64))
}
}

})